import { trackEvent } from '../utils/matomo';
import { useIntervalEffect } from './useIntervalEffect';
/**
 * A React hook that tracks the duration of a live video broadcast by sending
 * a tracking event every minute while enabled.
 *
 * Internally uses `useIntervalEffect` to trigger the event every 60 seconds.
 *
 * @param action - The analytics action string to associate with the event.
 * @param enabled - If `true`, the interval runs and tracks each minute; if `false`, tracking is paused.
 *
 * @example
 * useTrackBroadcastDurationEffect({
 *   action: 'Broadcast',
 *   enabled: isLive,
 * });
 */
export function useTrackBroadcastDurationEffect({ action, enabled, }) {
    useIntervalEffect(() => {
        trackEvent({
            category: 'Live Video',
            action,
            name: 'Minute',
            value: 1,
        });
    }, enabled ? 60_000 : undefined);
}
